import { render, staticRenderFns } from "./MetadadosCampoDinamicoBoolean.vue?vue&type=template&id=cae50228&"
import script from "./MetadadosCampoDinamicoBoolean.vue?vue&type=script&lang=js&"
export * from "./MetadadosCampoDinamicoBoolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/metadados/campos-dinamicos/MetadadosCampoDinamicoBoolean.vue
// module id = 1336
// module chunks = 28